import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { CopyMovePlaylistsModal } from "./CopyMovePlaylistsModal";
import PlaylistData from "../playlist/data/PlaylistData";
import { DeleteEntriesModal } from "../common/components/multiselectablelist/DeleteEntriesModal";
import { CyMultiChangeToolbar } from "./CyMultiChangeToolbar";
import { PlaylistIndexManipulator } from "./PlaylistIndexManipulator";
import { useTranslation } from "react-i18next";

interface Props {
  currentCrewIdentifier: string | undefined;
  setCurrentCrewIdentifier: (i: string | undefined) => void;
  selectedPlaylists: readonly PlaylistData[];
  performIndexRefresh: () => void;
}

export function MultiChangeToolbar({
  currentCrewIdentifier,
  setCurrentCrewIdentifier,
  selectedPlaylists,
  performIndexRefresh,
}: Props) {
  const { t } = useTranslation();
  const [isCopyMoveModalOpen, setIsCopyMoveModalOpen] =
    useState<boolean>(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  return (
    <>
      <CopyMovePlaylistsModal
        currentCrewIdentifier={currentCrewIdentifier}
        isModalOpen={isCopyMoveModalOpen}
        setIsModalOpen={setIsCopyMoveModalOpen}
        selectedPlaylists={selectedPlaylists}
        setCurrentCrewIdentifier={setCurrentCrewIdentifier}
        performIndexRefresh={performIndexRefresh}
      />
      <DeleteEntriesModal
        isModalOpen={isDeleteModalOpen}
        setIsModalOpen={setIsDeleteModalOpen}
        selectedEntries={selectedPlaylists}
        onEntriesDeleted={performIndexRefresh}
        deleteEntries={PlaylistIndexManipulator.deletePlaylists}
        modalTitle={t("playlist.deletePlaylists")}
        modalMessage={t("playlist.deletePlaylistsConfirm")}
      />
      <Row
        className={"mb-0 g-2 row-cols-auto "}
        data-cy={CyMultiChangeToolbar.Toolbar}
      >
        <Col>
          <Button
            color="primary"
            onClick={() => setIsDeleteModalOpen(true)}
            data-cy={CyMultiChangeToolbar.DeletePlaylists}
          >
            <FontAwesomeIcon icon={faTrashAlt} /> {t("common.buttons.delete")}
          </Button>
        </Col>
        <Col>
          <Button
            color="primary"
            onClick={() => setIsCopyMoveModalOpen(true)}
            data-cy={CyMultiChangeToolbar.CopyMovePlaylists}
          >
            <FontAwesomeIcon icon={faClone} /> {t("playlist.copyMove.title")}
          </Button>
        </Col>
      </Row>
    </>
  );
}
